export const timeline = {
  from: 2024,
  to: 2043,
  default: 2024
};
